<template>
  <v-row
    no-gutters
    class="tabs-wrapper"
    :class="{ 'fill-height': fillHeight, 'tabs-stretched': stretch, 'tabs-modern': modern }"
    :style="`${fillWidth ? 'width: 100%' : ''}`"
  >
    <v-col cols="12" :class="{ 'fill-height': fillHeight }">
      <v-row no-gutters v-if="!hideHeader">
        <v-col :cols="hasTabsTools ? 12 - tabsToolsCols : 12">
          <v-tabs
            v-if="tabsVisible"
            :value="value"
            @change="$emit('change', $event)"
            v-bind="$attrs"
            :hide-slider="!modern"
            :class="tabsClasses.join(' ')"
          >
            <v-tooltip bottom color="font" v-for="(tab, index) in tabs" :key="index" :disabled="!tab.disabled">
              <template #activator="{ on }">
                <div v-on="on" class="extra-div" :class="{ border: hasBorder, 'tw:p-1.5': modern }">
                  <v-tab
                    class="text-body-2 font--text"
                    :class="{ 'font-weight-regular': !modern }"
                    :ripple="modern ? false : undefined"
                    :disabled="tab.disabled"
                  >
                    <span class="">{{ tab.name }}</span>
                  </v-tab>
                </div>
              </template>
              {{ $i18n.t('snackbar.toolNotActive') }}
            </v-tooltip>
          </v-tabs>
        </v-col>
        <v-col :cols="tabsToolsCols" v-if="hasTabsTools">
          <slot name="tabsTools"> </slot>
        </v-col>
      </v-row>
      <slot name="top"> </slot>
      <v-tabs-items :value="value">
        <slot> </slot>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'GreyTabs',
  inheritAttrs: false,
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    fillHeight: {
      type: Boolean,
      default: false,
    },
    fillWidth: {
      type: Boolean,
      default: false,
    },
    stretch: {
      type: Boolean,
      default: false,
    },
    /** This should be default in the future */
    modern: {
      type: Boolean,
      default: false,
    },
    tabsClasses: {
      type: Array,
      default: () => {
        return [];
      },
    },
    hasTabsTools: {
      type: Boolean,
      default: false,
    },
    tabsToolsCols: {
      type: [Number, String],
      default: 2,
    },
    tabsVisible: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
@reference '@/tailwind.css';

.tabs-modern :deep(.v-slide-group__content) {
  @apply tw:grow-0! tw:bg-gray-100! tw:rounded-full! tw:border-0!;
}

.tabs-modern :deep(.v-tabs-slider-wrapper) {
  @apply tw:h-full! tw:py-1.5;
}
.tabs-modern :deep(.v-tabs-slider) {
  @apply tw:rounded-full! tw:bg-white! tw:shadow-sm!;
}

.tabs-modern :deep(.v-tab::before) {
  @apply tw:rounded-full!;
}
.tabs-modern :deep(.v-tab) {
  @apply tw:tracking-normal! tw:normal-case! tw:rounded-full! tw:z-[2];
}
.tabs-modern :deep(.v-tab--active::before) {
  content: none;
}

.tabs-modern :deep(.v-tab--active) {
  @apply tw:font-medium!;
}

/* Stretched tabs styles */
.tabs-stretched :deep(.v-slide-group__content) {
  @apply tw:w-full!;
}
.tabs-stretched :deep(.extra-div) {
  @apply tw:w-full!;
}
.tabs-stretched :deep(.v-tab) {
  @apply tw:grow!;
}
</style>

<style lang="scss" scoped>
.extra-div {
  display: flex;
  height: auto;
  box-sizing: content-box !important;
}

.tabs-wrapper:not(.tabs-modern) .extra-div:first-of-type.border {
  @include border(left);
}

.tabs-wrapper:not(.tabs-modern) .extra-div:last-of-type.border {
  @include border(right);
}

:deep(.v-window-item) {
  padding-top: 20px;
}

.tabs-wrapper:not(.tabs-modern) :deep(.v-tab) {
  text-transform: none;
  letter-spacing: 0.0892857143em;
  @include border(top);
  @include border(bottom);
}

.tabs-wrapper:not(.tabs-modern) :deep(.v-tab--active) {
  background-color: rgba(207, 207, 207, 0.25);
  font-weight: 500 !important;
}
</style>
